// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppARProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/app/ar", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.app.ar.TRAINING.id]: {
      img: protocolImg["./training_AR.png"],
      name: "training",
      video: "trainingVideo",
      description: "trainingDescription",
    },
    [protocols.app.ar.SHELVES.id]: {
      img: protocolImg["./shelves_AR.png"],
      name: "shelves",
      video: "shelvesVideo",
      description: "shelvesDescription",
    },
    [protocols.app.ar.BUFFET.id]: {
      img: protocolImg["./buffet_AR.png"],
      name: "buffet",
      video: "buffetVideo",
      description: "buffetDescription",
    },
    [protocols.app.ar.ALPHABET.id]: {
      img: protocolImg["./alphabet_AR.png"],
      name: "alphabet",
      video: "alphabetVideo",
      description: "alphabetDescription",
    },
    [protocols.app.ar.BALLOONS.id]: {
      img: protocolImg["./balloons_AR.png"],
      name: "balloons",
      video: "balloonsVideo",
      description: "balloonsDescription",
    },
    [protocols.app.ar.DUCKS.id]: {
      img: protocolImg["./ducks_AR.png"],
      name: "ducks",
      video: "ducksVideo",
      description: "ducksDescription",
    },
    [protocols.app.ar.SPHEROIDS.id]: {
      img: protocolImg["./spheroids_AR.png"],
      name: "spheroidsAR",
      video: "spheroidsARVideo",
      description: "spheroidsARDescription",
    },
    [protocols.app.ar.HOCKEY.id]: {
      img: protocolImg["./hockey_AR.png"],
      name: "hockeyAR",
      video: "hockeyARVideo",
      description: "hockeyARDescription",
    },
    [protocols.app.ar.CIRCLE.id]: {
      img: protocolImg["./circle_vertical_AR.png"],
      name: "circle",
      video: "circleVideo",
      description: "circleDescription",
    },
    [protocols.app.ar.WHAC_A_MOLE.id]: {
      img: protocolImg["./whac_a_mole_AR.png"],
      name: "whackAMoleAR",
      video: "whackAMoleARVideo",
      description: "whackAMoleARDescription",
    },
    [protocols.app.ar.TUBES.id]: {
      img: protocolImg["./tubes_AR.png"],
      name: "tubes",
      video: "tubesVideo",
      description: "tubesDescription",
    },
    [protocols.app.ar.CLEANING_AR.id]: {
      img: protocolImg["./cleaning_horizontal_AR.png"],
      name: "cleaningAR",
      video: "cleaningARVideo",
      description: "cleaningARDescription",
    },
    [protocols.app.ar.CLEANING_AR_VERTICAL.id]: {
      img: protocolImg["./cleaning_vertical_AR.png"],
      name: "cleaningARVertical",
      video: "cleaningARVerticalVideo",
      description: "cleaningARVerticalDescription",
    },
    [protocols.app.ar.CIRCLE_HORIZONTAL.id]: {
      img: protocolImg["./circle_horizontal_AR.png"],
      name: "circleHorizontal",
      video: "circleHorizontalVideo",
      description: "circleHorizontalDescription",
    },
    [protocols.app.ar.QUALITY_CONTROL.id]: {
      img: protocolImg["./quality_control_AR.png"],
      name: "qualityControl",
      video: "qualityControlVideo",
      description: "qualityControlDescription",
    },
    [protocols.app.ar.CONSTELLATIONS_AR.id]: {
      img: protocolImg["./constellations_AR.png"],
      name: "constellationsAR",
      video: "constellationsARVideo",
      description: "constellationsARDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
